import type {Options} from 'qr-code-styling'
import {colors} from '@/constants/theme/colors'

export const getQrConfig = (url: string): Partial<Options> => {
    return {
        type: 'canvas',
        shape: 'square',
        width: 150,
        height: 150,
        data: url,
        margin: 0,
        qrOptions: {
            mode: 'Byte',
            errorCorrectionLevel: 'Q'
        },
        imageOptions: {
            saveAsBlob: true,
            hideBackgroundDots: false,
            imageSize: 0.4,
            margin: 0
        },
        dotsOptions: {type: 'rounded', color: colors.dark, roundSize: true},
        backgroundOptions: {round: 0, color: colors.white, gradient: null},
        image: null,

        cornersSquareOptions: {type: 'extra-rounded', color: colors.dark}
    }
}
